import React from 'react';
// styles
import styled from 'styled-components';

const IntraserLogo = ({ className, ...props }) => (
  <svg
    {...props}
    role="img"
    aria-label="Intraser Logo"
    className={className}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 283.46 66.74"
    xmlSpace="preserve"
  >
    <g>
      <polygon class="st0" points="0,65.35 9.02,65.35 9.02,0 0,2.7 	" />
      <path
        class="st0"
        d="M42.14,26.86c-5.04,0-9.32,2.25-11.99,4.89v-4.93l-8.48,2.76v35.76h8.48V42.67c0-5,4.86-8.36,9.4-8.36
		c5.67,0,9.49,3.36,9.49,8.36v22.67h8.49V41.8C57.53,33.43,50.78,26.86,42.14,26.86z"
      />
      <path
        class="st0"
        d="M78.94,12.92l-8.48,2.76v11.19h-4.94l-2.94,7.54h7.88v19.57c0,3.84,1.46,12.77,15.03,12.77h1.03v-7.89h-1.03
		c-4.16,0-6.54-1.78-6.54-4.88V34.4h8.74v-7.54h-8.74V12.92z"
      />
      <path
        class="st0"
        d="M103.47,33.25v-6.34l-8.48,2.76v35.68h8.48V43.8c0-5.34,7.69-7.75,13.15-7.75h1.03v-8.58h-1.03
		C111.78,27.47,106.58,30.16,103.47,33.25z"
      />
      <path
        class="st0"
        d="M154.65,32.53c-2.99-3.4-7.72-5.67-12.35-5.67c-11.79,0-20.03,8.4-20.03,20.42c0,11.64,7.83,19.46,19.49,19.46
		c4.77,0,9.79-2.32,12.88-5.7v4.31h8.48V26.91l-8.48,2.76V32.53z M154.65,46.84c0,7.01-5,12.09-11.9,12.09
		c-6.84,0-11.81-5.09-11.81-12.09c0-7.06,4.97-12.18,11.81-12.18C149.76,34.67,154.65,39.67,154.65,46.84z"
      />
      <path
        class="st0"
        d="M187.21,42.73l-0.67-0.19c-4.12-1.15-7.54-2.26-7.54-4.22c0-2.56,3.06-4.1,6.01-4.1
		c3.79,0,8.99,1.51,10.71,3.12l1.74,1.62v-8.1l-0.29-0.3c-2.1-2.14-7.21-3.7-12.15-3.7c-7.05,0-14.58,3.01-14.58,11.46
		c0,8.15,8.73,10.35,12.93,11.41l0.79,0.2c4.91,1.17,8.13,2.12,8.13,4.56c0,4.6-5.9,4.96-7.71,4.96c-4.04,0-9.1-2.24-12.29-5.43
		l-1.76-1.76v8.83l0.3,0.3c3.24,3.25,8.64,5.34,13.75,5.34c10.14,0,16.19-4.58,16.19-12.24C200.77,46.49,191.95,44.05,187.21,42.73z
		"
      />
      <path
        class="st0"
        d="M225.25,26.86c-9.86,0-19.85,7.13-19.85,20.76c0,11.07,9.17,19.11,21.81,19.11c6.87,0,10.94-2.04,14.52-4.14
		l0.51-0.3v-8.21l-1.93,1.13c-3.34,1.96-6.5,3.81-13.1,3.81c-6.93,0-11.57-3.03-12.92-8.37h30.6l0.02-1.01
		c0.14-7.43-1.86-13.46-5.76-17.45C235.72,28.71,230.91,26.86,225.25,26.86z M214.39,43.03c1.31-5.21,5.29-8.28,10.86-8.28
		c6.68,0,10.1,4.62,10.66,8.28H214.39z"
      />
      <path
        class="st0"
        d="M260.26,33.25v-6.34l-8.48,2.76v35.68h8.48V43.8c0-5.34,7.69-7.75,13.15-7.75h1.03v-8.58h-1.03
		C268.58,27.47,263.37,30.16,260.26,33.25z"
      />
      <rect x="274.44" y="56.59" class="st0" width="9.02" height="8.76" />
    </g>
  </svg>
);

export default styled(IntraserLogo)`
  transform: scale(1.25) translate(45px, 0px);
`;
